import React from 'react'
import {
  AccessibleWebsite,
  AssistanceDog,
  AcousticSignals,
  AutomaticEntranceDoor,
  BarrierFreeAccessibility,
  Braille,
  BuildingPlanBraille,
  CommunicationAids,
  Dementia,
  EasyLanguage,
  ElevatorBraille,
  ElevatorSeat,
  ElevatorVisualDisplay,
  ElevatorVoiceAnnouncement,
  ElevatorWheelchairAccessible,
  EmergencyCallSystemsWheelchairAccessible,
  GuideSystemForTheBlind,
  HearingImpairment,
  HelpDementia,
  HelpMobility,
  HelpVisualImpairment,
  HighContrastLabeling,
  LightSignals,
  MedialOffers,
  NoStairs,
  ParkingWheelchairAccessible,
  Pictograms,
  ReligiousSpiritualReflection1,
  ReligiousSpiritualReflection2,
  RoomBraille,
  RoomSignalingSystems,
  RoomVisualDisplay,
  SanitaryFacilitiesWheelchairAccessible,
  SignLanguageInterpreter,
  VisualImpairment,
  WaitingAreaVisualDisplay,
  WCGenderfree,
  WCWheelchairAccessible,
} from '@aok/icon-accessibility'

export const getAccessibilityIcon = (iconKey) => {
  switch (iconKey) {
    case 'accessible-website':
      return <AccessibleWebsite />
    case 'assistance-dog':
      return <AssistanceDog />
    case 'acoustic-signals':
      return <AcousticSignals />
    case 'automatic-entranceDoor':
      return <AutomaticEntranceDoor />
    case 'barrier-free-accessibility':
      return <BarrierFreeAccessibility />
    case 'braille':
      return <Braille />
    case 'building-plan-braille':
      return <BuildingPlanBraille />
    case 'communication-aids':
      return <CommunicationAids />
    case 'dementia':
      return <Dementia />
    case 'easy-language':
      return <EasyLanguage />
    case 'elevator-braille':
      return <ElevatorBraille />
    case 'elevator-seat':
      return <ElevatorSeat />
    case 'elevator-visual-display':
      return <ElevatorVisualDisplay />
    case 'elevator-voice-announcement':
      return <ElevatorVoiceAnnouncement />
    case 'elevator-wheelchair-accessible':
      return <ElevatorWheelchairAccessible />
    case 'emergency-call-systems-wheelchair-accessible':
      return <EmergencyCallSystemsWheelchairAccessible />
    case 'guide-system-for-the-blind':
      return <GuideSystemForTheBlind />
    case 'hearing-impairment':
      return <HearingImpairment />
    case 'help-dementia':
      return <HelpDementia />
    case 'help-mobility':
      return <HelpMobility />
    case 'help-visual-impairment':
      return <HelpVisualImpairment />
    case 'high-contrast-labeling':
      return <HighContrastLabeling />
    case 'light-signals':
      return <LightSignals />
    case 'medial-offers':
      return <MedialOffers />
    case 'no-stairs':
      return <NoStairs />
    case 'parking-wheelchair-accessible':
      return <ParkingWheelchairAccessible />
    case 'pictograms':
      return <Pictograms />
    case 'religious-spiritual-reflection-1':
      return <ReligiousSpiritualReflection1 />
    case 'religious-spiritual-reflection-2':
      return <ReligiousSpiritualReflection2 />
    case 'room-braille':
      return <RoomBraille />
    case 'room-signaling-systems':
      return <RoomSignalingSystems />
    case 'room-visual-display':
      return <RoomVisualDisplay />
    case 'sanitary-facilities-wheelchair-accessible':
      return <SanitaryFacilitiesWheelchairAccessible />
    case 'sign-language-interpreter':
      return <SignLanguageInterpreter />
    case 'visual-impairment':
      return <VisualImpairment />
    case 'waiting-area-visual-display':
      return <WaitingAreaVisualDisplay />
    case 'wc-genderfree':
      return <WCGenderfree />
    case 'wc-wheelchair-accessible':
      return <WCWheelchairAccessible />
  }
}
